import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';
import {useScreenSize} from '../components/hooks/useScreenSize';  
import {useThemes} from '../components/hooks/hooks-mongoDB/useThemes';
import '../home/home.scss';
import '../css/fonts/fonts.scss';

function Home() {
    const {themes} = useThemes();
    const threeThemes = themes.slice(0, 3) || [];
    const regioneTheme = themes[3]; // Prende direttamente l'elemento all'indice 3
    const tipoTheme = themes[8]; // Prende direttamente l'elemento all'indice 8
    const vitignoTheme = themes[9]; // Prende direttamente l'elemento all'indice 9

    const [isSmartView, setIsSmartView] = useState(false);
    const smartSize = useScreenSize(600);

    useEffect(() => {
            if(smartSize){
                setIsSmartView(true);
            }else {
                setIsSmartView(false);
            }
        }, [smartSize]); 

    return (
        <section>
            <div className="container-home">
                {/* Abruzzo Wine */}
                <div className="home-imgs">
                {threeThemes.map(theme => (
                        <div className='img-btn' key={theme._id}>
                            <img src={require(`../components/images/home/primapagina/${theme.imgOne}`)} alt={`${theme.name} theme`} />
                            <Link className="btn__link" to={theme.collegamento}>
                                <button><span>{theme.nav_title} </span></button>
                            </Link>
                        </div> 
                    ))}
                </div>
            </div>
            {/* Province */}
            { isSmartView ?
            (regioneTheme && <div className="container__navlinks" key={regioneTheme._id}>
                <div className='navlink__btn'>
                    <img src={require(`../components/images/province/intestato/${regioneTheme.imgOne}`)} alt={`${regioneTheme.name} theme`} />
                    <Link className="btn__link" to={regioneTheme.collegamento}>
                        <button><span>Province</span></button>
                    </Link>
                </div>
                <div className="navlink__articolo">
                    <h2 className="navlink__titolo">{regioneTheme.name}</h2>
                    <p className="navlink__paragraph">{regioneTheme.description} </p>
                </div>
            </div>
            ):(
            regioneTheme && <div className="container__navlinks-smart" key={regioneTheme._id}>
                <div className="navlink__articolo-smart">
                    <h2 className="navlink__titolo-smart">{regioneTheme.name}</h2>
                    <p className="navlink__paragraph-smart">{regioneTheme.description} </p>
                    <div className='navlink__btn-smart'>
                        <img src={require(`../components/images/province/intestato/${regioneTheme.imgOne}`)} alt={`${regioneTheme.name} theme`} />
                        <Link className="btn__link" to={regioneTheme.collegamento}>
                            <button><span>Province</span></button>
                        </Link>
                    </div>
                </div>
            </div>
            )}

            {/* Tipologie */}
            { isSmartView ?
            (tipoTheme && <div className="container__navlinks" key={tipoTheme._id}>
                <div className='navlink__btn'>
                    <img src={require(`../components/images/tipologia/intestato/${tipoTheme.imgOne}`)} alt={`${tipoTheme.name} theme`} />
                    <Link className="btn__link" to={tipoTheme.collegamento}>
                        <button><span>Tipologie</span></button>
                    </Link>
                </div>
                <div className="navlink__articolo">
                    <h2 className="navlink__titolo">{tipoTheme.name}</h2>
                    <p className="navlink__paragraph">{tipoTheme.description} </p>
                </div>
            </div>
            ):(
			tipoTheme && <div className="container__navlinks-smart" key={tipoTheme._id}>
                <div className="navlink__articolo-smart">
                    <h2 className="navlink__titolo-smart">{tipoTheme.name}</h2>
                    <p className="navlink__paragraph-smart">{tipoTheme.description} </p>
                    <div className='navlink__btn-smart'>
                        <img src={require(`../components/images/tipologia/intestato/${tipoTheme.imgOne}`)} alt={`${tipoTheme.name} theme`} />
                        <Link className="btn__link" to={tipoTheme.collegamento}>
                            <button><span>Tipologie</span></button>
                        </Link>
                    </div>
                </div>
            </div>
            )}
            {/* Vitigni */}
            { isSmartView ?
            (vitignoTheme && <div className="container__navlinks" key={vitignoTheme._id}>
                <div className='navlink__btn'>
                    <img src={require(`../components/images/vitigno/intestato/${vitignoTheme.imgOne}`)} alt={`${vitignoTheme.name} theme`} />
                    <Link className="btn__link" to={vitignoTheme.collegamento}>
                        <button><span>Vitigni</span></button>
                    </Link>
                </div>
                <div className="navlink__articolo">
                    <h2 className="navlink__titolo">{vitignoTheme.name}</h2>
                    <p className="navlink__paragraph">{vitignoTheme.description} </p>
                </div>
            </div>
            ):(
			vitignoTheme && <div className="container__navlinks-smart" key={vitignoTheme._id}>
                <div className="navlink__articolo-smart">
                    <h2 className="navlink__titolo-smart">{vitignoTheme.name}</h2>
                    <p className="navlink__paragraph-smart">{vitignoTheme.description} </p>
                    <div className='navlink__btn-smart'>
                        <img src={require(`../components/images/vitigno/intestato/${vitignoTheme.imgOne}`)} alt={`${vitignoTheme.name} theme`} />
                        <Link className="btn__link" to={vitignoTheme.collegamento}>
                            <button><span>Vitigni</span></button>
                        </Link>
                    </div>
                </div>
            </div>
            )}

            {threeThemes.map(theme => 
            isSmartView ? (
            <div className="container__navlinks" key={theme._id}>
                <div className='navlink__btn'>
                    <img src={require(`../components/images/home/primapagina/${theme.imgTwo}`)} alt={`${theme.name} theme`} />
                    <Link className="btn__link" to={theme.collegamento}>
                        <button><span>{theme.nav_title}</span></button>
                    </Link>
                </div>
                <div className="navlink__articolo">
                    <h2 className="navlink__titolo">{theme.name}</h2>
                    <p className="navlink__paragraph">{theme.description} </p>
                </div>
            </div>
            ):(
			<div className="container__navlinks-smart" key={theme._id}>
                <div className="navlink__articolo-smart">
                    <h2 className="navlink__titolo-smart">{theme.name}</h2>
                    <p className="navlink__paragraph-smart">{theme.description} </p>
                    <div className='navlink__btn-smart'>
                        <img src={require(`../components/images/home/primapagina/${theme.imgTwo}`)} alt={`${theme.name} theme`} />
                        <Link className="btn__link" to={theme.collegamento}>
                            <button><span>Avanti</span></button>
                        </Link>
                    </div>
                </div>
            </div>
            ))}
        </section>
    )
}
export default Home;
